import axios from 'axios';
import { BABYFACE_URL } from '../../../lib/routes/Routes';
import { ERROR_RETRY } from '../../../lib/Error';

export const resendGift = async ({ voucherOrderId, voucherOrderInfo }) => {
  try {
    await axios.put(
      BABYFACE_URL.concat(
        `/purchased-voucher/${voucherOrderId}/resend-message`,
      ),
      voucherOrderInfo,
    );
    alert('재전송이 완료되었습니다.');
  } catch (e) {
    alert(ERROR_RETRY);
  }
};
